import { App } from 'vue'
// https://docs.sentry.io/platforms/javascript/guides/vue/#vue-3
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

import { cookies } from '@/utils/cookie'
import router from '@/router'

export const sentry = {
  install: (app: App) => {
    const isDEV = import.meta.env.DEV
    if (!isDEV) {
      const VueIntegration = Integrations.BrowserTracing
      Sentry.init({
        app,
        dsn: 'https://8e6fc77d975946e7bfe3f12ce3d9b3a0@trap.cekid.com/143',
        environment: 'production',
        integrations: [
          new VueIntegration({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router)
          })
        ],
        release: '' // --sentry release--
      })
      Sentry.setUser({
        uid: cookies.get('uid')
      })
    }
  }
}
